
import {useEffect, useState} from 'react';
import {ConnectivityStatus} from '@qep/types/src/index';
import {Hasi} from '@qep/common';

export function useConnectivity(statusNames: Array<keyof ConnectivityStatus>): Partial<ConnectivityStatus> {
  const statuses = statusNames.reduce((acc, statusName) => {
    acc[statusName] = globalThis.QEP.connectivity.getStatus(statusName);
    return acc;
  }, {});

  const [connectivityStatuses, setConnectivityStatuses] = useState<
    Partial<ConnectivityStatus>
  >(statuses);

  useEffect(() => {
    const offHandler = globalThis.QEP.connectivity.listenToStatusesChange((newStatuses: Hasi[]) => {
      const updatedStatuses = statusNames.reduce((acc, statusName) => {
        acc[statusName] = newStatuses.find(newStatus => statusName === newStatus.componentName);
        return acc;
      }, {});
      setConnectivityStatuses(updatedStatuses);
    });

    return offHandler;
  }, []);

  return connectivityStatuses;
}
